import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/searchGlass.svg'


const _hoisted_1 = { class: "clip-art-component" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search-input",
  id: "img-wrap"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("input", {
  style: {"display":"none"},
  type: "submit"
}, null, -1)
const _hoisted_5 = { id: "loading-icon" }
const _hoisted_6 = {
  key: 0,
  version: "1.1",
  id: "loader-1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "40px",
  height: "40px",
  viewBox: "0 0 50 50",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ff6c00",
  d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "0.6s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { id: "categories" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Popular Categories", -1)
const _hoisted_12 = { id: "icons-wrap" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  id: "after-search"
}
const _hoisted_16 = { id: "after-search-icons-wrap" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!
  const _component_Customize = _resolveComponent("Customize")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    (!_ctx.currentActiveObject || _ctx.currentActiveObject.name !== 'clipArt')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            id: "search",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _hoisted_3,
            _createElementVNode("input", {
              placeholder: "Search for clipart",
              id: "search-input",
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
            }, null, 32),
            _hoisted_4
          ], 32),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "clear",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearIcons && _ctx.clearIcons(...args)))
                }, "Clear"))
          ]),
          (!_ctx.icons.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clipArtImages, (art, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "icon",
                        key: idx,
                        onClick: ($event: any) => (_ctx.handleClick(art.path))
                      }, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/clipcats/${art.path}.svg`)
                        }, null, 8, _hoisted_14),
                        _createElementVNode("p", null, _toDisplayString(art.name), 1)
                      ], 8, _hoisted_13))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "after-search-icon",
                      key: idx,
                      onClick: ($event: any) => (_ctx.addToCanvas(icon.id))
                    }, [
                      _createElementVNode("img", {
                        src: icon.icon_url
                      }, null, 8, _hoisted_18)
                    ], 8, _hoisted_17))
                  }), 128))
                ])
              ]))
        ]))
      : (_openBlock(), _createBlock(_component_Customize, { key: 1 }))
  ]))
}